/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Video from '../partials/Video';
import Body from '../partials/Body';

import styles from '../../../styles/blocks/video.module.scss';

const propTypes = {
    url: PropTypes.string, // eslint-disable-line
    title: PropTypes.string,
    body: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    url: null,
    title: null,
    body: null,
    className: null,
};

const VideoBlock = ({ url, title, body, className }) => {
    return url ? (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {title ? (
                <h3 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
            ) : null}
            <Video className={styles.video} url={url} />
            {body ? <Body className={styles.body} body={body} /> : null}
        </div>
    ) : null;
};

VideoBlock.propTypes = propTypes;
VideoBlock.defaultProps = defaultProps;

export default VideoBlock;
